import { RegistrationService } from './../services/registration.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../core/localstorage.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {

  emailData: FormGroup;
  emailtext = true;
  verifiedMail = false;
  constructor(private fb: FormBuilder, private router: Router,
    private localstorageservice: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private registrationService: RegistrationService
    ) {

  }

  ngOnInit() {
    this.emailData = this.fb.group({
      email: ['', Validators.required],
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      if (Object.keys(params).length > 0) {
        let token = params["token"];
        let tokenid = params["token_id"];

        let param = {
          email: atob(tokenid),
          token: token
        }
        this.verifyEmailId(param);
      }
    });
  }

  verifyEmailId(obj) {
    this.registrationService.verifyEmail(obj).subscribe(data => {
      if(data){
        this.verifiedMail = true;
        setTimeout(() => {
          this.router.navigate(["/login"]);
        }, 2000);
      }
    }, error => {
      this.emailtext = false;
    })
  }

}
